import React from "react";
import { Switch, Redirect, Route } from "react-router-dom";
// Define you derived routes that use Route with Layout.
import RouteWithLayout from "./Components/RouteWithLayout";
import LoadingWrapper from "./Utils/LoadingWrapper/LoadingWrapper";
import { NotFoundView } from "./Views";
import { useAuthContext } from "./Context/AuthContext";
import {
  routesList,
  publicRoutesId,
  institutionRoutesId,
  adminRoutesId,
} from "./RoutesComp";

const Routes = () => {
  const { authState } = useAuthContext();
  const { isAuthenticated, userInfo } = authState;
  const userRole = userInfo?.role || "public";

  let derivedRoutes = [];
  switch (userRole) {
    case "admin":
      derivedRoutes = routesList.filter(({ id }) => adminRoutesId.includes(id));
      break;
    case "institution":
      derivedRoutes = routesList.filter(({ id }) =>
        institutionRoutesId.includes(id)
      );
      break;
    case "public":
      derivedRoutes = routesList.filter(({ id }) =>
        publicRoutesId.includes(id)
      );
      break;
    default:
      break;
  }
  if (!userInfo) {
    return <LoadingWrapper />;
  }
  let slashRedirect = "/";
  if (userRole === "admin") {
    slashRedirect = "/badges";
  }
  if (userRole === "institution") {
    slashRedirect = "/i/speakers";
  }
  console.log(slashRedirect, authState);
  return (
    <Switch>
      {/*  */}

      {derivedRoutes.map((route) => {
        return (
          <RouteWithLayout
            key={route.id}
            component={route.component}
            layout={route.layout}
            path={route.path}
            setting={route.setting}
            exact
          />
        );
      })}

      <Route exact path="/">
        <Redirect to={slashRedirect} />
      </Route>
      {/* <Route exact path="/s/login">
        <Redirect
          to={isAuthenticated ? `/ss/${userInfo?.userName}` : "/s/login"}
        />
      </Route> */}

      <Route exact path="/not-found" component={NotFoundView} />
      <Route component={NotFoundView} />
    </Switch>
  );
};

export default Routes;
